// Re-export gtag as googleAnalytics here so we can limit the number of usages of window directly
export const googleAnalytics: typeof gtag | undefined = window.gtag;
export const googleAnalyticsMeasurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
